import React, { Component } from 'react';
import { Body, Header, Wrapper, FooterBar } from '../postStyles'
import JournalInfo from '../JournalInfo'

class FoundDocumentaryJournal extends Component {
    render() {
        return (
            <Wrapper>
                <Header>
                    <img src="https://i.ibb.co/dLX8SCg/20200512232240.jpg" alt="cover"/>
                    <div className="info">
                        <h1>
                            [found] documentary reflections
                        </h1>
                        <div className="date">11/12/2021</div>
                    </div>
                </Header>
                <Body>
                    <div className="paragraph">
                    I used to tease my mom for enjoying documentaries so much. They were, aside from 
                    the occasional reality TV show, her go-to forms of film entertainment. We laughed 
                    about how she chooses to indulge in them while I would only watch them if I were 
                    forced to so for a class. But like mother like daughter, I'm discovering that my 
                    enjoyment in documentaries is being kindled as well.
                    </div>
                    <div className="paragraph"> 
                    I watched <i>Found</i> recently. There is something about the rawness of these unadorned 
                    footages that is quietly moving and eminently intimate. In the words of Zach Loveall from 
                    <a href='https://www.michigandaily.com/film/found-and-the-intimacy-of-documentaries/' target='_blank' rel='noreferrer'>
                    The Michigan Daily,</a>
                    <i>"Sometimes all you need for a captivating story is a camera pointed 
                    at a person going through an important event, no embellishment is required."</i> With all dramatic 
                    effects and extravagant filters set aside, the plain telling of another's narrative and the undecorated 
                    depiction of reality is sufficient as art. Perhaps at the end of the day art does imitate life and life 
                    in its raw simplicity and wild complexity, is sufficient as art.
                    </div>
                    <div className="paragraph">
                    In the documentary, three adopted American girls (Lily, Sadie, and Chloe) who are related by 
                    blood found each other through an online platform. Together, they embarked on an unravelling 
                    of their lost history by connecting with Liu Hao, a genealogist who takes on the task of helping 
                    the girls search for their biological parents. Eventually, they travelled across the world together 
                    to reconnect with the place that they were born in.
                    </div>
                    <div className="paragraph">
                    Spoiler alert, none of them did find their biological parents in the end. But it is the in-between 
                    pilgrimage — the intricate emotional journeys and small reconstruction of the inner worlds that 
                    the individuals went through  — that felt more important. 
                    </div>
                    <img src="https://i.ibb.co/34qHFVZ/Group-14.png" alt="documentary moment"/>
                    <div className="paragraph">
                    Over the past year I have grown increasingly curious about Asian diaspora. How we originated 
                    from the same place but come to be dispersed across a myriad of different locations — what becomes 
                    of us as we depart from our motherland?
                    </div>
                    <div className="paragraph">
                    Right on the cusp of me finishing elementary school, my family left China. The years I have spent 
                    on either lands each occupy about half of my life and my growing pains spread out almost evenly 
                    across these two distinct geographical locations.
                    My overall impression of the cities remained honey-dipped with childhood simplicity, until my revisit 
                    last year. Coinciding with the eruption of the pandemic, I lingered long enough on this familiar-yet-strange 
                    homeland so I could no longer remain as an observer of the rushing crowd but to join as a participant. 
                    A cultural re-shock was encountered, in an, <i>Oh, there is so much more beyond the parameters of what 
                    I have defined to be normal</i>, kinda way.
                    </div>
                    <div className="paragraph">
                    The cultural tapestry and the rush of crowds felt familar, but I was a stranger wandering among the 
                    recognizable streets. It felt like parallel universes, a myriad of passengers capturing alternative 
                    lives that I could have possibly been living instead. In moments like these I experienced a fraction 
                    of what the girls might have felt  — a wonderment at the arbitrariness of fate and the butterfly-effect 
                    process that has shaped us into who we are.
                    </div>
                    <div className="paragraph">
                    I wonder if they feel a longing for a motherland that is in their blood but not their memory, a curiosity 
                    for an entirely different life that they might have otherwise known. I wonder how it felt for them to walk 
                    through the completely foreign streets and know — <i>this could have been home</i>.
                    </div>
                    <div className="paragraph">
                    To what extent do our experiences become a part of who we are us? Our world views are invariably shaped by 
                    everywhere we’ve ever been and everything we’ve ever walked through. Perhaps every geographical space I have 
                    temprorarily resided continues to inhabit inside a part of me. Each one of us nevertheless remains as a story 
                    in the writing, unbounded by the geography nor circumstances within our past.
                    </div>
                    <div className="paragraph">
                    I wonder if I might have ended up alright, even if the dominoes did not tumble in the exact alignment that led me 
                    to where I am today. But despite how seemingly arbitrary life is, perhaps all of it unfolded just as it was meant to.
                    </div>
                    <img src="https://i.ibb.co/VT9xMV2/IMG-20211126-235510.png" alt="documentary moment"/>
                    <div className="paragraph">
                    At one scene, the father of Chen receives the news that Lily is not actually biologically related to them. He tries 
                    to look away from the camera nonchalently, but the camera nevertheless captured a glimpse of the uncontainable sorrow 
                    spilling over at the edge of his eyes. While the girls reconcile  with the bittersweet sentiments of retracing to their 
                    history of being abandoned, the other side of the story portray the biological parents who unwillingly gave up the children 
                    they held dear to. 
                    </div>
                    <div className="paragraph">
                    Larger societal forces like socioeconomic statuses and the Once Child Policy in China have the power of completely rewriting 
                    the tragectory of an individual's plotline. I recall a book I have read, <i>Little Fires Everywhere,</i> where a story of a mother and 
                    her abandoned-then-adopted child is captured. In a scene, Mrs. Richardson considers the complicated situation faced by Bebe Chow, 
                    an immigrant mother fighting over the custody of her child, and how she should respond if she was to be confronted with it. 
                    Unable to conjure up a neat solution, she decides instead that it is something that she would not have let happened to her 
                    in the first place, simply by making better choices along the way. Yet as the omniscient readers understand at that point, 
                    it is not possibly as simple as that. The world is far from perfectible and we find ourselves in the nebulous gap between 
                    the polarities of right and wrong. Sometimes the only choices that remain before us are ones that invariably lead to heartache, 
                    in one way or the other.
                    </div>
                    <div className="paragraph">
                    Desipte the magnitude of these inevitable forces, hearing from the other side of the story nevertheless brings one a sense of solace. 
                    In the scenes to follow, Chen sister pours jugs of honey for the girls to take home as the most down-to-earth gesture of amiability 
                    that their family could offer. After departure, Lily reflects upon the moment in realization that perhaps her parents were just as 
                    unwilling to give her up as Chen family and their daughter.
                    </div>
                    <img src="https://i.ibb.co/942y4VB/Group-15.png" alt="documentary moment"/>
                    <div className="paragraph">
                    I'm invited to ponder upon numerous more things:
                    </div>
                    <div className="paragraph">
                    The invisible and irreplaceable ways others in our lives has shaped us — the way the nannies tenderly cared for the adoptees during 
                    their earliest days.
                    </div>
                    <div className="paragraph">
                    The power technology has to enable possibilities and rekindle lost connections — how the girls found each other in the first place 
                    through web platforms. 
                    </div>
                    <div className="paragraph">
                    The way we resonate with the narrative of another — how Liu Hao ponders upon her own poignant history with the One Child Policy and 
                    systemic sexism to empathize with the experience of the girls.
                    </div>
                    <div className="paragraph">
                    The fact that an individual is not reduced one happenstance — how the girls, with their vibrantly distinct personalities and the loving 
                    relationships that surround them, are not defined by their experience of being adopted.
                    </div>
                    <div className="paragraph">
                    The family that we found in one another — how the adoptive parents cherish and nurture their daughters in a way that eclipses the 
                    definitions of biological bond.
                    </div>
                    <hr/>
                    <div className="paragraph">
                    In truth, I have never been one to binge TV shows nor watch an excessive amount of movies, mainly because it takes 
                    quite a bit of emotional energy to immerse myself into a story. In other words, I can't help but put to paper what 
                    is lingering on my mind after I watch something. This generally makes me watch a lot less because it's kinda a lot of work. 
                    </div>
                    <div className="paragraph">
                    But it seems worthwhile to be doing this anyway — capturing what  — so here are my scattered reflections after watching 
                    the documentary Found. 
                    </div>
                    <div className="paragraph">
                    At the end of the day, the intricate workings of the world that we have constructed and the world that we inhabit will 
                    continue to be a subject of fascination for me. I appreciate anything that allows me to glimpse into a hue on the spectrums 
                    of human experience that I might not have otherwise known.
                    </div>
                </Body>
                <FooterBar 
                next={JournalInfo['indigo']}
                previous={JournalInfo['beingbelonging']}/>
            </Wrapper>
        )
    }
}

export default FoundDocumentaryJournal